/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarketplaceMetadataApiModel } from '../../models/marketplace-metadata-api-model';

export interface GetMarketplaceMetadata$Params {
}

export function getMarketplaceMetadata(http: HttpClient, rootUrl: string, params?: GetMarketplaceMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<MarketplaceMetadataApiModel>> {
  const rb = new RequestBuilder(rootUrl, getMarketplaceMetadata.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MarketplaceMetadataApiModel>;
    })
  );
}

getMarketplaceMetadata.PATH = '/marketplace/metadata';
